<template>
    <section aria-label="object-weather">
        <div class="table-grid row">
            <div class="col">
                <img
                    v-if="data.icon?.fullpath"
                    :src="apiUrl + data.icon.fullpath"
                    width="30"
                    :alt="data.name"
                />
            </div>
            <div class="col" v-if="stepsMade === 0">
                {{ data.name }}
            </div>
            <div class="col" v-else>
                Wetter
            </div>
            <div class="col">
                <v-layout
                    style="margin: 0 !important"
                    row
                    align-center

                    class="my-10"
                >
                    <v-img
                        max-width="20"
                        class="mr-1"
                        v-if="icon"
                        :src="
                            'https://openweathermap.org/img/wn/' + icon + '.png'
                        "
                    />
                    <span class="temp">{{
                            temperature ? temperature + ' °C' : 'N/A'
                        }}</span>
                </v-layout>
            </div>
        </div>
    </section>
</template>

<script setup>
import { defineProps, computed, ref, onMounted } from 'vue'

const apiUrl = process.env.VUE_APP_API_URL

const props = defineProps({
    data: Object,
    item: Object,
    stepsMade: {
        type: Number,
        default: 0
    }
})

const weatherData = ref(null)

onMounted(() => {
    if (props.data.output) {
        try {
            weatherData.value = JSON.parse(props.data.output)
        } catch {
            weatherData.value = null
        }
    }
})

const temperature = computed(() => {
    if (!weatherData.value || !weatherData.value[props.stepsMade]?.temp?.day) return ''

    return Math.floor(weatherData.value[props.stepsMade].temp.day)

})

const icon = computed(() => {
    if (!weatherData.value || !weatherData.value[props.stepsMade]) return ''

    return weatherData.value[props.stepsMade]?.weather?.[0]?.icon ?? ''
})
</script>

<style lang="scss" scoped>
.temp {
    display: flex;
    align-items: center;
    margin-left: 0.25rem;
}
</style>
